import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconChevronDoubleRightSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-chevron-double-right-sharp__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m11.793 17.293-.707.707 1.414 1.414.707-.707 6-6 .707-.707-.707-.707-6-6-.707-.707L11.086 6l.707.707L17.086 12l-5.293 5.293Zm-7 0L4.086 18 5.5 19.414l.707-.707 6-6 .707-.707-.707-.707-6-6-.707-.707L4.086 6l.707.707L10.086 12l-5.293 5.293Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icon-chevron-double-right-sharp__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconChevronDoubleRightSharp);
export default Memo;
